import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import Cookie from 'cookie-universal';
import { Axios } from '../API/Axios';

const cookieJar = Cookie();

// نفس فكرة CartChangerContext بالظبط، بس للمفضلة
const WishlistContext = createContext( null );

export const WishlistProvider = ( { children } ) =>
{
    const [ wishlist, setWishlist ] = useState( [] );
    const [ loading, setLoading ] = useState( false );
    const [ wishlistChanged, setWishlistChanged ] = useState( true );

    const isLoggedIn = () => !!cookieJar.get( 'ecommerce' );

    const fetchWishlist = useCallback( async () =>
    {
        if ( !isLoggedIn() )
        {
            setWishlist( [] );
            return;
        }
        setLoading( true );
        try
        {
            const res = await Axios.get( '/wishlist' );
            setWishlist( res.data );
        } catch ( error )
        {
            console.log( 'Error fetching wishlist:', error );
        } finally
        {
            setLoading( false );
        }
    }, [] );

    useEffect( () =>
    {
        fetchWishlist();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ wishlistChanged ] );

    // هل المنتج ده موجود بالفعل في المفضلة؟ (مفيدة لتلوين زر القلب في صفحة المنتج)
    const isInWishlist = useCallback(
        ( productId ) => wishlist.some( ( item ) => item.product_id === productId ),
        [ wishlist ]
    );

    async function addToWishlist ( productId )
    {
        if ( !isLoggedIn() )
        {
            return { success: false, reason: 'auth' };
        }
        try
        {
            await Axios.post( '/wishlist', { product_id: productId } );
            setWishlistChanged( ( prev ) => !prev );
            return { success: true };
        } catch ( error )
        {
            return { success: false, reason: 'error' };
        }
    }

    async function removeFromWishlist ( productId )
    {
        try
        {
            await Axios.delete( `/wishlist/${ productId }` );
            setWishlistChanged( ( prev ) => !prev );
            return { success: true };
        } catch ( error )
        {
            console.log( 'Error removing from wishlist:', error );
            return { success: false };
        }
    }

    // زر واحد بيضيف/يشيل حسب الحالة الحالية - مريح للاستخدام في زر القلب
    async function toggleWishlist ( productId )
    {
        if ( isInWishlist( productId ) )
        {
            return removeFromWishlist( productId );
        }
        return addToWishlist( productId );
    }

    return (
        <WishlistContext.Provider value={ {
            wishlist,
            loading,
            isLoggedIn,
            isInWishlist,
            addToWishlist,
            removeFromWishlist,
            toggleWishlist,
        } }>
            { children }
        </WishlistContext.Provider>
    );
};

export function useWishlist ()
{
    return useContext( WishlistContext );
}

export default WishlistContext;
